<p-select
  [options]="options"
  [(ngModel)]="selectedOption"
  appendTo="body"
  emptyMessage="Sin resultados"
  [placeholder]="placeholder"
  class="base-field field-select"
/>
